export const permissions = {
  /// srmt
  SRMTBox: 'SRMTBox',
  SRMTFraudAlerts: 'SRMTFraudAlerts',
  SRMTInfoAlerts: 'SRMTInfoAlerts',
  SRMTPlayersGroup: 'SRMTPlayersGroup',
  SRMTSettings: 'SRMTSettings',
  SRMTDashboardAndAnalyticData: 'SRMTDashboardAndAnalyticData',
  SRMTReports: 'SRMTReports',
  SRMTExport: 'SRMTExport',
  /// LCRMT
  LCRMTBox: 'LCRMTBox',
  LCRMTAdmin: 'LCRMTAdmin',
  LCRMTExport: 'LCRMTExport',
  LCRMTReport: 'LCRMTReport',
  LCRMTAlertMonitor: 'LCRMTAlertMonitor',
  LCRMTSettings: 'LCRMTSettings',

  /// aml
  AMLBox: 'AMLBox',
  AMLRGGeneral: 'AMLRGGeneral',
  AMLSettings: 'AMLSettings',
  AMLExport: 'AMLRGProductBoxExport',

  /// risk weekly report (standalone feature)
  RiskWeeklyReport: 'RiskWeeklyReport',

  /// common
  PlayersListAndIndividualPage: 'PlayersListAndIndividualPage',
  AdminPanel: 'AdminPanel',
  /// dbo.Resource Id 9000 (ActivityLog), Read access granted per role / user
  ActivityLog: 'ActivityLog',

  /// CRMT
  CRMTBox: 'CRMTBox',
  CRMTPlayersGroup: 'CRMTPlayersGroup',
  CRMTAlertMonitor: 'CRMTAlertMonitor',
  CRMTCumulativeLoss: 'CRMTCumulativeLoss',
  CRMTGameAnomalies: 'CRMTGameAnomalies',
  CRMTPlayerAnomalies: 'CRMTPlayerAnomalies',
  CRMTSettings: 'CRMTSettings',

  /// GRMT
  GeneralBox: 'GRMTBox',
  GRMTPlayersGroupCasino: 'GRMTPlayersGroupCasino',
  GRMTPlayersGroupSport: 'GRMTPlayersGroupSport',
  GRMTAdmin: 'GRMTAdmin',
  GRMTDashboard: 'GRMTDashboard',
  GRMTMainDashboard: 'GRMTMainDashboard',
  GRMTAlertCorrection: 'GRMTAlertCorrection',
  GRMTOperationsDashboard: 'GRMTOperationsDashboard',
  GeneralSettings: 'GRMTSettings',
  GRMTCategorySettings: 'GRMTCategorySettings',
  GeneralAlertMonitor: 'GRMTAlertMonitor',
  GeneralPlayersSports: 'GRMTPlayersSports',
  GeneralPlayersCasino: 'GRMTPlayersCasino',
  GeneralPlayersPayments: 'GRMTPlayersPayments',
  GeneralPlayersGeneral: 'GRMTPlayersGeneral',
  GeneralGameSports: 'GRMTGameSports',
  GeneralGameCasino: 'GRMTGameCasino',
  GRMTPartner: 'GRMTPartner',
  GRMTReports: 'GRMTReports'
};
